import { Box, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import './SideMenu/index.css';

const TabButtonWrapper: React.FC<{
  isSelected?: boolean;
  className?: string;
  [name: string]: unknown;
}> = ({ isSelected, className, ...props }) => {
  if (!isSelected) return <TabButton className={className} {...props} />;
  return (
    <Box
      position="relative"
      className={`sidemenu-tab-button ${className ?? ''}`}
    >
      <TabButton
        disableRipple
        style={{ minWidth: '60px', marginTop: 0 }}
        {...props}
      />
    </Box>
  );
};

const TabButton = withStyles(theme => {
  const tab = theme.sideMenuTab;
  return {
    root: {
      width: '60px',
      minWidth: '60px',
      height: '56px',
      backgroundColor: tab.background,
      opacity: 1,
      boxShadow: tab.shadow,
      borderRadius: '0px 16px 16px 0px',
      fill: tab.iconFill,
      transition: 'background-color 0.2s, fill 0.2s',
      '& img': {
        filter: tab.imgFilter,
        opacity: 0.75,
      },
    },
    selected: {
      fill: theme.palette.primary.main,
      backgroundColor: tab.backgroundSelected,
      boxShadow: tab.shadowSelected,
      filter: 'none',
      '& img': {
        filter: 'none',
        opacity: 1,
      },
    },
  };
})(Tab);

export default TabButtonWrapper;
